import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { useCommonStyles } from '../Styles';

function InnerTabGridItemButtonGroup(props) {
  const classes = useCommonStyles();
  const {
    children,
  } = props;
  return (
    <Grid item>
      <Paper variant="outlined" className={classes.innerTablButtonGroup}>
        {children}
      </Paper>
    </Grid>
  );
}

export default InnerTabGridItemButtonGroup;
